import { render, staticRenderFns } from "./RedPack.vue?vue&type=template&id=1938d7de&scoped=true&"
import script from "./RedPack.vue?vue&type=script&lang=js&"
export * from "./RedPack.vue?vue&type=script&lang=js&"
import style0 from "./RedPack.vue?vue&type=style&index=0&id=1938d7de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1938d7de",
  null
  
)

export default component.exports